const MousemoveParallax = {};

// Instance must have a parallaxLayers Array.
// Layers must have a z-parameter Float.
// Layers pivot must not be changed outside.

MousemoveParallax.startParallax = (instance, f) => {
    if (instance.parallaxOn) return;
    const MouseInteractionSingleton = require('../../../viscomjs/interactions/MouseInteractionSingleton');
    const mis = MouseInteractionSingleton();

    instance.updateParallax = function () {
        MousemoveParallax.updateParallax(this, this.misInstance);
        if (typeof f === 'function')
            f(this, this.misInstance);
    };

    instance.parallaxOn = true;
    instance.misInstance = mis;

    instance.app.ticker.add(instance.updateParallax, instance);
}

MousemoveParallax.updateParallax = (instance, misInstance) => {
    if (!instance.parallaxLayers || instance.parallaxLayers.length < 1) return;
    let layer;
    let i;
    for (i = 0; i < instance.parallaxLayers.length; i++) {
        layer = instance.parallaxLayers[i];
        layer.pivot.x = misInstance.vector.x * layer.z * misInstance.normalizedWidth * 0.05;
        layer.pivot.y = misInstance.vector.y * layer.z * misInstance.normalizedHeight * 0.05 * (layer.zYFactor || 1);
    }
}

MousemoveParallax.stopParallax = instance => {
    if (!instance.parallaxOn) return;

    instance.parallaxOn = false;
    instance.app.ticker.remove(instance.updateParallax, instance);
}

module.exports = MousemoveParallax;




// WEBPACK FOOTER //
// ./js/viscom/vereschagin/timelines/utils/MousemoveParallax.js